import { render, staticRenderFns } from "./Replace.vue?vue&type=template&id=5a23c702&"
import script from "./Replace.vue?vue&type=script&lang=js&"
export * from "./Replace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports